import { Input, Typography, Select } from '@oresundsbron/bridge-ui';
import { useForm } from '@oresundsbron/use-form';
import { FC } from 'react';
import { Data, Labels, Placeholders } from './types';

export const PaperInvoiceForm: FC<{
  namespace: string;
  labels: Labels;
  countryOptions: { key: string; value: string }[];
  placeholders: Placeholders;
}> = ({ namespace, labels, countryOptions = [], placeholders }) => {
  const { registerField, getError, isActive } = useForm<Data>({ namespace });

  return (
    <>
      <Typography intent="title" className="col-span-full mt-2">
        {labels.paperInvoiceTitle}
      </Typography>
      <Typography intent="label" size="sm" className="col-span-full">
        {labels.requiredFields}
      </Typography>
      <Input
        className="col-span-full"
        {...registerField('invoice.attentionName')}
        error={getError('invoice.attentionName')}
        label={labels.attentionName}
        required
        disabled={!isActive}
      />
      <Select
        className="col-span-full sm:col-span-4 md:col-span-6"
        {...registerField('invoice.country')}
        label={labels.country}
        options={countryOptions.map((c) => ({ ...c, label: c.key }))}
        placeholder={placeholders.country}
        error={getError('invoice.country')}
        disabled={!isActive}
        required
      />

      <Input
        className="col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
        {...registerField('invoice.address')}
        label={labels.address}
        error={getError('invoice.address')}
        required
        disabled={!isActive}
      />
      <Input
        className="col-span-full sm:col-span-4 md:col-span-6"
        {...registerField('invoice.zipCode')}
        error={getError('invoice.zipCode')}
        label={labels.zipCode}
        required
        disabled={!isActive}
      />
      <Input
        className="col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
        {...registerField('invoice.city')}
        error={getError('invoice.city')}
        label={labels.city}
        required
        disabled={!isActive}
      />
    </>
  );
};
